import { SectionCard, TableWrapper } from 'components/insights/careTransitions/shared/tableStyles';

import { SharedAnalytics } from '../BusinessDevelopmentDashboard';

import BusinessDevelopmentTable from './BusinessDevelopmentTable';
import BusinessDevelopmentTableHeader from './BusinessDevelopmentTableHeader';

type Props = {
  data: SharedAnalytics;
};

export default function BusinessDevelopmentTableSection({ data }: Props) {
  return (
    <SectionCard>
      <BusinessDevelopmentTableHeader />
      <TableWrapper>
        <BusinessDevelopmentTable loading={data.loading} rollups={data.rollups} />
      </TableWrapper>
    </SectionCard>
  );
}
